import { Injectable } from '@angular/core';
import { CashierCommonService } from './cashier.common.service';
import { CASHIER_PAGES, paymentMethods } from '../config/cashier.config';
import { AjaxService } from '../../services/ajax.service';
import { EmitterService } from '../../services/emitter.service';
import { UserDetailsService } from '../../services/user-details.service';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class IFrameService {
  transactionId;
  requestLoopCount = 0;
    constructor(private cashierCommonService:CashierCommonService,
       private ajaxService:AjaxService,
        private emitterService:EmitterService,
        private userDetailsService:UserDetailsService,
        private messageService:MessageService) {
     }
  
     makePaymentMethodTransaction(requestObj){ 
      let isNewWindow = false;
      paymentMethods.filter((method)=>{
        if(method.name == requestObj.paymentMethod){
          isNewWindow = method.isNewWindow;
          return
        }
      })
      requestObj = this.cashierCommonService.getRedirectionUrls(requestObj);
      this.ajaxService.makePayment(requestObj).then((transactionData:any)=>{
        if( transactionData["status"] == "SUCCESS" && transactionData["redirectURL"]) {
          localStorage.setItem("iframePaymentMethodTxnID", transactionData["txnId"]);
          this.cashierCommonService.generateIframe(transactionData["redirectURL"], isNewWindow);
        } else {
          this.messageService.genericTransactionMessage();
        }
       }).catch((error)=>{
        this.messageService.genericTransactionMessage();
       })
     }
  
     updateTransactionDetails(event){
      if(event && event.data && typeof event.data == 'string'){
        let transactionDetails = JSON.parse(event.data);
        if(transactionDetails && transactionDetails.event == 'user_left_session'){
          this.emitterService.broadCastCustomerCashierTransactionStatusChange({page:CASHIER_PAGES.PAYEMENT_DETAILS_PAGE,message:'',isLoading:false});
        }else if(transactionDetails && transactionDetails.event == 'session_succeeded'){
         this.emitterService.broadCastCashierLoader(true);
          let txnId = localStorage.getItem('iframePaymentMethodTxnID');
          this.transactionHandlerWithTxnId(txnId);
        }else if(transactionDetails && transactionDetails.event == 'session_failed'){
          this.messageService.failureTransactionMessage('session_failed');
        }else if(transactionDetails && transactionDetails.event == 'session_error'){
          this.messageService.genericTransactionMessage();
        }
      }
     }
     
     transactionHandlerWithTxnId(txnId){
      localStorage.removeItem('iframePaymentMethodTxnID');
      let data = { txnId:txnId, type:'DEPOSIT' };
      this.ajaxService.getTransactionStatus(data).then((txnData)=>{
        if(txnData['actualStatusInDB'] == "txn_confirmed_success"){
          let userCurrency = this.userDetailsService.getUserCurrencySymbol();
          this.messageService.successTransactionMessage({txnAmount:userCurrency+txnData['transactionAmount'],
                                                         amount:txnData['transactionAmount'],
                                                         transactionId:txnId
                                                        });
        }else{
           ++this.requestLoopCount;
          if(this.requestLoopCount <= 3){
           setTimeout(()=>{  this.transactionHandlerWithTxnId(txnId)},3000)
          }else{
            this.requestLoopCount = 0;
            this.messageService.failureTransactionMessage('');
            localStorage.removeItem('transactionStatusIsLoading');
          }
          
        }
        
      }).catch((error)=>{
        console.log(error);
        this.messageService.genericTransactionMessage();
        localStorage.removeItem('transactionStatusIsLoading');
      })
     }
}
